import React from 'react';
import PropTypes from 'prop-types';
import ResponsivePicture from '../../../Elements/ResponsivePicture/ResponsivePicture';
import './FocusArea.scss';

// i.e. Single Resource (article, download, event) Banner

const maxHeights = {
    desktop: 400,
    tablet: 205,
    smallTablet: 100,
    mobile: 85,
};

const bps = {
    desktop: { width: 1500 },
    tablet: { width: 992 },
    smallTablet: { width: 768 },
    mobile: { width: 575 },
};

export default class FocusArea extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
    };

    static defaultProps = {};

    render() {
        const { src, alt } = this.props;
        return (
            <div className="component-Employer-Marketing-FocusArea">
                <div className="focus-area-container">
                    <ResponsivePicture
                        forceImageSize
                        useShine
                        className="responsive-picture"
                        cloudinaryID={src}
                        alt={alt}
                        breakpoints={bps}
                        maxHeights={maxHeights}
                    />
                </div>
            </div>
        );
    }
}
